// Home Ask: when the view switches from "initial" to "conversation", the composer slides from where it was (centered
// in the hero) to its fixed spot at the bottom of the content area. A JS animation (Web Animations API, FLIP):
// the layout jumps to the final position at once and the composer is moved back by the old offset, then released.
// prefers-reduced-motion: no animation, the composer is simply at the bottom.

/** Slide duration in ms (the requirement allows about 400 ms at most). */
export const COMPOSER_SLIDE_MS = 350;

export function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/**
 * Animates `el` from `fromTop` (its viewport top before the layout change) to where it is now. Returns the animation,
 * or null when nothing moves (reduced motion, no offset, or no Web Animations support).
 */
export function slideComposer(el: HTMLElement, fromTop: number, reduced: boolean = prefersReducedMotion()): Animation | null {
  if (reduced || typeof el.animate !== "function") return null;
  const delta = fromTop - el.getBoundingClientRect().top;
  if (!Number.isFinite(delta) || Math.abs(delta) < 1) return null;
  return el.animate([{ transform: `translateY(${delta}px)` }, { transform: "translateY(0)" }], { duration: COMPOSER_SLIDE_MS, easing: "ease-out" });
}
